const SalesOrders = [
  // PreOrders
  {
    path: '/preOrders',
    name: 'preOrders',
    component: () => import('@/components/preorder/PreOrders'),
  },
  {
    path: '/view-all-preorders',
    name: 'view-all-preorders',
    component: () => import('@/components/preorder/ViewAllPreOrder'),
  },
  // Waybill Order Report
  {
    path: '/waybill-order-report-preview',
    name: 'waybill-order-report-preview',
    component: () => import('@/components/reports/WaybillOrderReportPreview'),
  },
  //Waybills Orders
  {
    path: '/waybills',
    name: 'waybills',
    component: () => import('@/components/preorder/Waybills'),
  },

  // sales orders
  {
    path: '/orders',
    name: 'orders',
    component: () => import('@/components/orders/Orders'),
  },
  //View Orders

  {
    path: '/view-orders',
    name: 'view-orders',
    component: () => import('@/components/preorder/ViewOrders'),
  },
  {
    path: '/order-details/',
    name: 'order-details',
    component: () => import('@/components/orders/OrdersDetails'),
    props: true,
  },
  //AggregateOrders

  {
    path: '/aggregate-order',
    name: 'aggregate-order',
    component: () => import('@/components/preorder/AggregateOrders'),
  },
  
];

export default SalesOrders;
